import * as React from "react";
import * as ReactDOMClient from 'react-dom/client';
import { Main } from "./Main";

import "@mapgear/geoapps-ui-framework/dist/index.css";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container as Element);
root.render(<Main />);
